import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GatewayService } from "../api/gateway.service";

/** State and action returned by {@link useRevokeSession}. */
export interface UseRevokeSessionReturn {
    /** Revoke the current user's session with the given id. */
    revokeSession: (sessionId: string) => Promise<unknown>;
    loading: boolean;
    error: Error | null;
}

/** Revoke one of the current user's own device sessions (instant logout of it). */
export const useRevokeSession = (): UseRevokeSessionReturn => {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: (sessionId: string) => GatewayService.revokeSession(sessionId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["gateway", "sessions"] });
        },
    });
    return {
        revokeSession: (sessionId) => mutation.mutateAsync(sessionId),
        loading: mutation.isPending,
        error: mutation.error,
    };
};
